/**
 * The one task drawer that slides in over any page (lib/task-flyout.ts).
 * Mounted once in the app shell. Closing it puts you back where you were —
 * same page, same scroll — because nothing navigated.
 */
import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { TaskDrawer } from "@/components/task-drawer";
import { TASK_FLYOUT_EVENT } from "@/lib/task-flyout";

export function TaskFlyoutHost() {
    const [taskId, setTaskId] = useState<string | null>(null);
    const location = useLocation();
    const path = useRef(location.pathname);

    useEffect(() => {
        const onOpen = (e: Event) => {
            const id = (e as CustomEvent<{ taskId?: string } | undefined>).detail?.taskId;
            if (id) setTaskId(id);
        };
        window.addEventListener(TASK_FLYOUT_EVENT, onOpen);
        return () => window.removeEventListener(TASK_FLYOUT_EVENT, onOpen);
    }, []);

    // A button inside the drawer that goes somewhere else (e.g. "Open the
    // quote") changes the page — the drawer goes with the old page.
    useEffect(() => {
        if (path.current !== location.pathname) {
            path.current = location.pathname;
            setTaskId(null);
        }
    }, [location.pathname]);

    return <TaskDrawer taskId={taskId} onClose={() => setTaskId(null)} />;
}
